export const CONSTANT = "CONSTANT";

export const APP = "APP";
export const APP_FORM = "APP_FORM";

export const DIALOG_SET = "DIALOG_SET";
export const DIALOG_CLOSE = "DIALOG_CLOSE";
export const DIALOG_DATA_ADD = "DIALOG_DATA_ADD";

export const USER = "USER";
export const ROLE = "ROLE";

export const ACTIVE = "ACTIVE";

export const REQUESTS = "REQUESTS";

export const RESOURCES = "RESOURCES";
export const RESOURCES_HOST = "RESOURCES_HOST";
export const RESOURCES_SERVER = "RESOURCES_SERVER";
export const RESOURCES_SERVERS = "RESOURCES_SERVERS";
export const RESOURCES_ORGANIZATION = "RESOURCES_ORGANIZATION";
export const RESOURCES_ORGANIZATIONS = "RESOURCES_ORGANIZATIONS";
export const RESOURCES_USER_ORGANIZATION = "RESOURCES_USER_ORGANIZATION";
export const RESOURCES_organizationUserDetails = "RESOURCES_organizationUserDetails";

export const RESOURCES_organizationPackageMapping = "RESOURCES_organizationPackageMapping";
export const RESOURCES_organizationPackageMapping_forOrg = "RESOURCES_organizationPackageMapping_forOrg";

export const SEARCH_ACTION = "SEARCH_ACTION";

export const USER_CAN_USER_EDIT_INSTANCE = "USER_CAN_USER_EDIT_INSTANCE";



// WEBPACK FOOTER //
// ./src/actions/constants.js